function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EventEmitter from '@antv/event-emitter';
var layerCounter = 0;

/**
 * 图层管理器
 */
export var LayerManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(LayerManager, _EventEmitter);
  var _super = _createSuper(LayerManager);
  function LayerManager(options) {
    var _this;
    _classCallCheck(this, LayerManager);
    _this = _super.call(this);
    /**
     * 地图容器
     */
    _defineProperty(_assertThisInitialized(_this), "scene", void 0);
    /**
     * 配置项
     */
    _defineProperty(_assertThisInitialized(_this), "options", void 0);
    /**
     * 图层
     */
    _defineProperty(_assertThisInitialized(_this), "layerMap", new Map());
    _this.scene = options.scene;
    _this.options = options;
    return _this;
  }

  /**
   * 是否有该图层
   */
  _createClass(LayerManager, [{
    key: "hasLayer",
    value: function hasLayer(id) {
      return this.layerMap.has(id);
    }

    /**
     * 添加图层
     */
  }, {
    key: "addLayer",
    value: function addLayer(layer) {
      var layerId = this.getLayerId(layer);
      this.layerMap.set(layerId, layer);
      layer.addTo(this.scene);
      this.emit('add', layer);
    }

    /**
     * 添加多个图层
     */
  }, {
    key: "addLayers",
    value: function addLayers(layers) {
      var _this2 = this;
      layers.forEach(function (layer) {
        _this2.addLayer(layer);
      });
    }

    /**
     * 根据图层 id 或图层实例移除 layer 图层
     */
  }, {
    key: "removeLayer",
    value: function removeLayer(id) {
      var layerId = typeof id === 'string' ? id : this.getLayerId(id);
      var findLayer = this.layerMap.get(layerId);
      if (!findLayer) return false;
      this.layerMap.delete(layerId);
      findLayer.remove();
      this.emit('remove', layerId);
      return true;
    }

    /**
     * 获取图层组所有的图层
     */
  }, {
    key: "getLayers",
    value: function getLayers() {
      return Array.from(this.layerMap.values());
    }

    /**
     * 根据图层 ID 获取图层
     */
  }, {
    key: "getLayerById",
    value: function getLayerById(id) {
      return this.layerMap.get(id);
    }
  }, {
    key: "getLayer",
    value: function getLayer(id) {
      return this.getLayerById(id);
    }

    /**
     * 移除所有的图层对象
     */
  }, {
    key: "removeAllLayer",
    value: function removeAllLayer() {
      var _iterator = _createForOfIteratorHelper(this.layerMap.values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var layer = _step.value;
          layer.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.layerMap.clear();
    }

    /**
     * 是否图层为空
     */
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.layerMap.size === 0;
    }

    /**
     * 根据图层获取图层 ID
     */
  }, {
    key: "getLayerId",
    value: function getLayerId(layer) {
      if ('id' in layer) {
        return layer.id;
      }
      return "".concat(layerCounter++);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.removeAllLayer();
    }
  }]);
  return LayerManager;
}(EventEmitter);